<template>
  <div class="flex h-full flex-col gap-6">
    <div class="-mt-6 flex h-full flex-col items-center justify-center">
      <BaseMemberAvatars
        size="96"
        :members="[dialog.coach, dialog.coachee]"
        class="bg-surface-container-lowest"
      />
      <h1 class="text-display-large mt-6 mb-2">Dialog mit {{ dialogWith.firstName }}</h1>
      <CoacheeDialogTimeline :dialog="dialog" class="max-w-4xl pt-10" />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'
  import { useUserStore } from '../../../stores/user.store'
  import BaseMemberAvatars from '../../../core/components/base/avatar/BaseMemberAvatars.vue'
  import { injectStrict } from '@/core/utils/inject-strict'
  import { dialogKey } from '../composable/use-dialog-navigation'
  import CoacheeDialogTimeline from '@/modules/coachees/components/CoacheeDialogTimeline.vue'

  const dialog = injectStrict(dialogKey)

  const { user } = useUserStore()

  const dialogWith = computed(() => {
    if (dialog.coach.id == user.id) {
      return dialog.coachee
    }
    return dialog.coach
  })
</script>
